module.exports = __webpack_public_path__ + "img/start_session.2b62c740.svg";